// https://stackoverflow.com/questions/15458876/check-if-a-string-is-html-or-not
const isHTML = (str) => {
	const doc = new DOMParser().parseFromString(str, 'text/html');
	return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
};

export default isHTML;
